import { Grid } from "@material-ui/core";
import { useContext, memo } from "react";
import Card from "../../../../components/cards/Card";
import { TemplateContractsContext } from "../contexts/ContractsContext";
import { DivHeandleEmail } from "../styles/ModalContracts";
import Fieldset from "../../../../components/basics/Fieldset";
import { HeaderAccordion } from "../styles/ModalContracts";
import Chip from "../../../../components/basics/Chip";
import EditorEmail from "../../../../components/inputs/EditorEmail";
import InputRadio from "../../../../components/inputs/InputRadio";
import { useEffect } from "react";
import { contractLayouts } from "../constants/contratomodelo";
import { InfoRounded } from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";

const ModalContracts = ({ location }) => {
  const {
    emailEditorBody,
    tagListBody,
    bodyDesign,
    setExportDataEditor,
    layoutContract,
    setLayoutContract,
    setBodyDesign,
  } = useContext(TemplateContractsContext);

  useEffect(() => {
    if (!layoutContract?.value && location?.state?.item?.id) return;
    setBodyDesign(contractLayouts[layoutContract?.value]);
  }, [layoutContract, location?.state?.item?.id, setBodyDesign]);

  useEffect(() => {
    if (location?.state?.item?.id) return;
    setTimeout(() => {
      setBodyDesign(contractLayouts.contract);
    }, 1000);
  }, [location?.state?.item?.id, setBodyDesign]);

  return (
    <>
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip label="TEXTO" bgcolor="secondary" />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded={false}
      >
        <Grid item container spacing={1} xs={12}>
          <Grid
            item
            container
            xs
            alignItems="flex-end"
            justifyContent="space-between"
          >
            <Grid item xs={10}>
              {!location?.state?.item?.id && (
                <InputRadio
                  row
                  label="Tipo de Modelo"
                  options={[
                    { label: "Contrato", value: "contract" },
                    { label: "Pedido", value: "order" },
                    { label: "Em branco", value: "blank" },
                  ]}
                  value={layoutContract}
                  setValue={setLayoutContract}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              Atenção ao adicionar uma imagem!
              <Tooltip title="O nome do arquivo de imagem não pode conter: espaço entre as palavras, caracteres especiais ( / \ : * < > | “ ' ) e letras com acentuação (á, ã, é, í, ó, ó, ú, ç …)">
                <InfoRounded />
              </Tooltip>
            </Grid>
          </Grid>

          <Card fullWidth line="left" style={{ marginTop: 10 }}>
            <DivHeandleEmail>
              <EditorEmail
                editorRef={emailEditorBody}
                mergeTags={tagListBody}
                design={bodyDesign}
                setExportData={setExportDataEditor}
              />
            </DivHeandleEmail>
          </Card>
        </Grid>
      </Fieldset>
    </>
  );
};

export default memo(ModalContracts);
